import React from "react";
import Button from "@material-ui/core/Button";
import LinkIcon from "@material-ui/icons/Link";

export default ({ label, href }) => (
    <a href={href} target="_blank" style={{ textDecoration: "none" }}>
        <Button size="medium" color="primary">
            <LinkIcon />
            &nbsp;{label}
        </Button>
    </a>
);



// WEBPACK FOOTER //
// ./src/components/OuterLink.js